import { So5FixtureEvent } from '#src/__generated__/globalTypes.ts';
import { useConfigContext } from '#src/contexts/config/index.ts';

export const useNextSo5FixtureTeamSlugs = (
  eventType: So5FixtureEvent = So5FixtureEvent.CLASSIC
) => {
  const {
    so5: { teamsPlayingNextClassicGameWeeks, teamsPlayingNextDailyGameWeeks },
  } = useConfigContext();

  return eventType === So5FixtureEvent.CLASSIC
    ? teamsPlayingNextClassicGameWeeks
    : teamsPlayingNextDailyGameWeeks;
};
